import { render, staticRenderFns } from "./ModalLicenseAndSale.vue?vue&type=template&id=2be24350&scoped=true&"
import script from "./ModalLicenseAndSale.vue?vue&type=script&lang=js&"
export * from "./ModalLicenseAndSale.vue?vue&type=script&lang=js&"
import style0 from "./ModalLicenseAndSale.vue?vue&type=style&index=0&id=2be24350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be24350",
  null
  
)

export default component.exports